<template>
  <div :class="{ active: isActive }" class="support-btn-con">
    <Tooltip :content="'Help'" placement="bottom">
      <Icon @click.native="gotoSupport" type="md-help" :size="24"></Icon>
    </Tooltip>
  </div>
</template>

<script>
export default {
  name: "Help",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive() {
      return this.$route.name === "support";
    },
  },
  mounted() {},
  methods: {
    gotoSupport() {
      this.$router.push({ name: "support" });
    },
  },
};
</script>